import "./scene-1.css";

const phrases = [" TECHNOLOGY", " CREATIVITY", " DELIVERY EXPERIENCE"];
const h1 = "scene-1-text";
const effectSpan = "scene-1-span";

function fadeText(element, effectSpan) {
  let phrase = phrases.shift();
  phrases.push(phrase);

  const h1 = document.querySelector(`.${element}`);
  const oldSpan = document.querySelector(`.${effectSpan}`);

  if (oldSpan) {
    h1.removeChild(oldSpan);
  }

  const span = document.createElement("span");
  span.classList.add("fade");
  span.classList.add(effectSpan);
  span.textContent = phrase;
  h1.appendChild(span);
}

setInterval(fadeText, 2000, h1, effectSpan);
